/* eslint-disable func-names */
var Plugins = function Plugins() {};
var p = Plugins.prototype;
p.push = function (plugin) {
  this[plugin.prototype.name] = plugin;
};
export default new Plugins();


//////////////////
// WEBPACK FOOTER
// ../~/rc-tween-one/es/plugins.js
// module id = 597
// module chunks = 1